import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
}

export const Card: React.FC<CardProps> = ({ children, className = '', title, subtitle }) => {
  return (
    <div className={`bg-surface border border-white/10 rounded-sm p-6 relative overflow-hidden ${className}`}>
      {/* Subtle digital accent */}
      <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl from-white/5 to-transparent pointer-events-none"></div>
      
      {(title || subtitle) && (
        <div className="mb-5">
          {title && <h3 className="text-lg font-bold uppercase tracking-wide text-white">{title}</h3>}
          {subtitle && <p className="text-xs text-slate-400 font-mono uppercase tracking-widest mt-1">{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  );
};